<template>
  <div id="app">
    <notifications class="main-notification" group="foo" position="top center" width="100%" classes="custom-notify" />
    <keep-alive :include="keepAlive">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  computed: {
    keepAlive() {
      return this.$store.getters.keepAlive;
    },
  },
  created() {
    if (localStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(localStorage.getItem('store'))));
    }
  },
};
</script>

<style>
html {
  height: 100%;
  color: #333333;
}
body {
  height: 100%;
  margin: 0px;
  font-size: 16px;
}
a {
  cursor: pointer;
}
input::placeholder {
  color: #bbbbbb;
}
button,
.solid-btn {
  cursor: pointer;
  font-size: 14px;
  border: none;
  color: #ffffff;
  border-radius: 4px;
  padding: 2px 10px;
  min-width: 60px;
  margin: 0px 4px;
  display: inline-block;
  background-color: #5d89c0;
}
.hollow-btn {
  cursor: pointer;
  font-size: 14px;
  color: #5d89c0;
  border-radius: 4px;
  border: 1px solid #5d89c0;
  padding: 2px 10px;
  min-width: 60px;
  margin: 0px 4px;
  display: inline-block;
  background-color: #ffffff;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.clickable {
  color: #5d89c0;
  cursor: pointer;
}
div[class$='-container'] {
  padding: 36px 50px 0px 301px;
  text-align: left;
  min-width: 1440px;
  min-height: 800px;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  box-sizing: border-box;
  scrollbar-width: none;
}
div[class$='-container']::-webkit-scrollbar {
  display: none;
}
.main-notification .notification-content {
  font-size: 18px;
  text-align: center;
}
.custom-notify {
  padding: 10px;
}
.custom-notify.custom-red {
  color: #e02020;
  background: #ffeaea;
}
.custom-notify.custom-blue {
  color: #5d89c0;
  background: #eff3f8;
}
.custom-notify.custom-yellow {
  color: #ee9729;
  background: #fff6ea;
}
select {
  background: none;
}
</style>
